import { Location } from 'history'
import React, { ReactElement } from 'react'
import { RouteProps } from 'react-router'
import { Action, AnyAction } from 'redux'
import { ThunkAction } from 'redux-thunk'
import AccountAppRoute from 'src/navigation/appRoutes/account.appRoute'
import AccountsAppRoute from 'src/navigation/appRoutes/accounts.appRoute'
import ActionUnavailableAppRoute from 'src/navigation/appRoutes/actionUnavailable.appRoute'
import ActivityAppRoute from 'src/navigation/appRoutes/activity.appRoute'
import AddExpenseAppRoute from 'src/navigation/appRoutes/addExpense.appRoute'
import BillPayAppRoute from 'src/navigation/appRoutes/billPay.appRoute'
import BillPayDetailAppRoute from 'src/navigation/appRoutes/billPayDetail.appRoute'
import BudgetAppRoute from 'src/navigation/appRoutes/budget.appRoute'
import BudgetsAppRoute from 'src/navigation/appRoutes/budgets.appRoute'
import BulkUploadExpenseLabelsAppRoute from 'src/navigation/appRoutes/bulkUploadExpenseLabels.appRoute'
import CancelSubscriptionAppRoute from 'src/navigation/appRoutes/cancelSubscription.appRoute'
import CardsAppRoute from 'src/navigation/appRoutes/cards.appRoute'
import ChangePasswordAppRoute from 'src/navigation/appRoutes/changePassword.appRoute'
import CloseAccountAppRoute from 'src/navigation/appRoutes/closeAccount.appRoute'
import CloseBillPayCardAppRoute from 'src/navigation/appRoutes/closeBillPayCard.appRoute'
import CloseVirtualCardAppRoute from 'src/navigation/appRoutes/closeVirtualCard.appRoute'
import CreateAutomationRuleAppRoute from 'src/navigation/appRoutes/createAutomationRule.appRoute'
import CreateBillPayAppRoute from 'src/navigation/appRoutes/createBillPay.appRoute'
import CreateBudgetAppRoute from 'src/navigation/appRoutes/createBudget.appRoute'
import CreateVirtualCardAppRoute from 'src/navigation/appRoutes/createVirtualCard.appRoute'
import CspSigninAppRoute from 'src/navigation/appRoutes/cspSignin.appRoute'
import CspUserDetailAppRoute from 'src/navigation/appRoutes/cspUserDetail.appRoute'
import DeactivateBillPayCardAppRoute from 'src/navigation/appRoutes/deactivateBillPayCard.appRoute'
import DeactivateBudgetAppRoute from 'src/navigation/appRoutes/deactivateBudget.appRoute'
import DeactivateVirtualCardAppRoute from 'src/navigation/appRoutes/deactivateVirtualCard.appRoute'
import DownloadsAppRoute from 'src/navigation/appRoutes/downloads.appRoute'
import ExpenseReportAppRoute from 'src/navigation/appRoutes/expenseReports/expenseReport.appRoute'
import ExpensesAppRoute from 'src/navigation/appRoutes/expenses.appRoute'
import OrgExpenseReportAppRoute from 'src/navigation/appRoutes/expenses/expensesOrgExpenseReport.appRoute'
import OrgExpenseReportsHistoricalReportsAppRoute from 'src/navigation/appRoutes/expenses/expensesOrgExpenseReportsHistoricalReports.appRoute'
import FAQAppRoute from 'src/navigation/appRoutes/FAQ.appRoute'
import HelpAppRoute from 'src/navigation/appRoutes/help.appRoute'
import HomeAppRoute from 'src/navigation/appRoutes/home.appRoute'
import InsightsAppRoute from 'src/navigation/appRoutes/insights.appRoute'
import InvitePeopleAppRoute from 'src/navigation/appRoutes/invitePeople.appRoute'
import ManageOrgInviteAppRoute from 'src/navigation/appRoutes/manageOrgInvite.appRoute'
import ManagerReviewReimbursementAppRoute from 'src/navigation/appRoutes/managerReview/managerReviewReimbursement.appRoute'
import ManagerReviewTransactionsAppRoute from 'src/navigation/appRoutes/managerReview/managerReviewTransactions.appRoute'
import ManagerReviewReimbursementsAppRoute from 'src/navigation/appRoutes/managerReview/submitExpensesNeedsApproval.appRoute'
import ManageTrustedDevicesAppRoute from 'src/navigation/appRoutes/manageTrustedDevices.appRoute'
import MyWalletAppRoute from 'src/navigation/appRoutes/myWallet.appRoute'
import MyWalletReimbursementAppRoute from 'src/navigation/appRoutes/myWallet/myWalletReimbursement.appRoute'
import MyWalletVirtualCardDetailAppRoute from 'src/navigation/appRoutes/myWallet/myWalletVirtualCardDetail.appRoute'
import OnboardingAppRoute from 'src/navigation/appRoutes/onboarding.appRoute'
import DepartmentDetailsAppRoute from 'src/navigation/appRoutes/organization/departmentDetails.appRoute'
import ExpenseCategoryLabelsAppRoute from 'src/navigation/appRoutes/organization/expenseCategoryLabels.appRoute'
import ManageOrgIntegrationAppRoute from 'src/navigation/appRoutes/organization/manageOrgIntegration.appRoute'
import OrgInviteDecisionAppRoute from 'src/navigation/appRoutes/orgInviteDecision.appRoute'
import PeopleAppRoute from 'src/navigation/appRoutes/people.appRoute'
import PeopleInvitedToOrgDetailAppRoute from 'src/navigation/appRoutes/peopleInvitedToOrgDetail.appRoute'
import PeopleMembersDetailAppRoute from 'src/navigation/appRoutes/peopleMembersDetail.appRoute'
import PrivacyAppRoute from 'src/navigation/appRoutes/privacy.appRoute'
import ProfileAppRoute from 'src/navigation/appRoutes/profile.appRoute'
import RegisterAccountAppRoute from 'src/navigation/appRoutes/registerAccount.appRoute'
import RegisterOrganizationAppRoute from 'src/navigation/appRoutes/registerOrganization.appRoute'
import RemoveUserFromOrganizationAppRoute from 'src/navigation/appRoutes/removeUserFromOrganization.appRoute'
import RequestBudgetAppRoute from 'src/navigation/appRoutes/requestBudget.appRoute'
import RequestVirtualCardAppRoute from 'src/navigation/appRoutes/requestVirtualCard.appRoute'
import ResetPasswordAppRoute from 'src/navigation/appRoutes/resetPassword.appRoute'
import ScreenVirtualCardAppRoute from 'src/navigation/appRoutes/screenVirtualCard.appRoute'
import SearchAppRoute from 'src/navigation/appRoutes/search.appRoute'
import SetOrgExpenseReportCycleAppRoute from 'src/navigation/appRoutes/setOrgExpenseReportCycle.appRoute'
import ShareBillPayVirtualCardAppRoute from 'src/navigation/appRoutes/shareBillPayVirtualCardAppRoute'
import SigninAppRoute from 'src/navigation/appRoutes/signin.appRoute.tsx'
import SignupAppRoute from 'src/navigation/appRoutes/signup.appRoute'
import StreamingAgentAppRoute from 'src/navigation/appRoutes/streamingAgent.appRoute'
import SupportAppRoute from 'src/navigation/appRoutes/support.appRoute'
import TermsAppRoute from 'src/navigation/appRoutes/terms.appRoute'
import TransactionDetailAppRoute from 'src/navigation/appRoutes/transactionDetail.appRoute'
import TransactionsAppRoute from 'src/navigation/appRoutes/transactions.appRoute'
import UpdateAutomationRuleAppRoute from 'src/navigation/appRoutes/updateAutomationRule.appRoute'
import UpdateBillPayVirtualCardAppRoute from 'src/navigation/appRoutes/updateBillPayVirtualCard.appRoute'
import UpdateBudgetAppRoute from 'src/navigation/appRoutes/updateBudget.appRoute'
import UpdateBudgetRequestAppRoute from 'src/navigation/appRoutes/updateBudgetRequest.appRoute'
import UpdateBulkTransactionsAppRoute from 'src/navigation/appRoutes/updateBulkTransactions.appRoute'
import UpdateExpenseAppRoute from 'src/navigation/appRoutes/updateExpense.appRoute'
import UpdateProfilePhotoAppRoute from 'src/navigation/appRoutes/updateProfilePhoto.appRoute'
import UpdateVirtualCardAppRoute from 'src/navigation/appRoutes/updateVirtualCard.appRoute'
import UpgradeSubscriptionAppRoute from 'src/navigation/appRoutes/upgradeSubscription.appRoute'
import UserScreeningInfoAppRoute from 'src/navigation/appRoutes/userScreeningInfo.appRoute'
import VirtualCardsAppRoute from 'src/navigation/appRoutes/virtualCards.appRoute'
import {
  authenticationAgnosticRouteProps,
  baseRouteProps,
} from 'src/navigation/routeProps'
import * as Routes from 'src/navigation/urls'
/* HYGEN-INJECT-IMPORT */
import PricingPage from 'src/page-components/PricingPage/PricingPage'
import { RootState } from 'src/redux/createRootReducer'

import { AppLocation, SidenavContentType } from './appLocations'
import AccountingReviewReportsAppRoute from './appRoutes/accountingReviewReports.appRoute'
import VirtualCardDetailAppRoute from './appRoutes/virtualCardDetail.appRoute'

export interface AppRoute<A extends Action = AnyAction> {
  id?: AppLocation
  routeProps: RouteProps // used to match against
  component?: React.ReactElement
  fetch?: (location: Location) => ThunkAction<Promise<void>, RootState, void, A>
  exceptions?: Array<AppRoute<A>>
  subRoutes: Array<AppRoute<A>>
  meta?: {
    // TODO: make not optional
    contentType?: SidenavContentType // TODO: | undefined
  }
}

export const authenticationAgnosticAppRoute: AppRoute = {
  routeProps: authenticationAgnosticRouteProps, // needs to be specific to allow authed/unauthed to swap on everything else
  subRoutes: [FAQAppRoute, TermsAppRoute, PrivacyAppRoute, SupportAppRoute],
}

export const authedBackgroundAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    HomeAppRoute,
    VirtualCardDetailAppRoute,
    VirtualCardsAppRoute,
    ManagerReviewReimbursementsAppRoute,
    ManagerReviewTransactionsAppRoute,
    ManagerReviewReimbursementAppRoute,
    MyWalletReimbursementAppRoute,
    MyWalletVirtualCardDetailAppRoute,
    MyWalletAppRoute,
    CardsAppRoute,
    AccountsAppRoute,
    AccountAppRoute,
    BudgetsAppRoute,
    BudgetAppRoute,
    ActivityAppRoute,
    StreamingAgentAppRoute,
    InsightsAppRoute,
    ProfileAppRoute,
    TransactionsAppRoute,
    PeopleAppRoute,
    ExpensesAppRoute,
    BillPayDetailAppRoute,
    BillPayAppRoute,
    ExpenseReportAppRoute,
    AccountingReviewReportsAppRoute,
    // ExpenseCategoriesAppRoute,
    // DepartmentsAppRoute,
    // OrganizationIntegrationsAppRoute,
    // BusinessRulesAppRoute,
    // OrgSettingsReimbursementsAppRoute,
    // ReimbursementsAppRoute,
    // OrganizationInfoAppRoute,
    // ManageSubscriptionAppRoute,
    // APIKeysAppRoute,
    // AutomationSettingsAppRoute,
    ExpenseCategoryLabelsAppRoute,
    OnboardingAppRoute,
    OrgInviteDecisionAppRoute,
    OrgExpenseReportsHistoricalReportsAppRoute,
    OrgExpenseReportAppRoute,
    DepartmentDetailsAppRoute,
    DownloadsAppRoute,
  ],
}

export const authedPopupAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    ScreenVirtualCardAppRoute,
    DeactivateVirtualCardAppRoute,
    DeactivateBillPayCardAppRoute,
    DeactivateBudgetAppRoute,
    RegisterAccountAppRoute,
    UpdateProfilePhotoAppRoute,
    UpgradeSubscriptionAppRoute,
    UserScreeningInfoAppRoute,
    ActionUnavailableAppRoute,
    RegisterOrganizationAppRoute,
    ManageOrgInviteAppRoute,
    ManageOrgIntegrationAppRoute,
    RemoveUserFromOrganizationAppRoute,
    ChangePasswordAppRoute,
    ManageTrustedDevicesAppRoute,
    CloseVirtualCardAppRoute,
    CloseBillPayCardAppRoute,
    CloseAccountAppRoute,
    SetOrgExpenseReportCycleAppRoute,
    ShareBillPayVirtualCardAppRoute,
    CancelSubscriptionAppRoute,
  ],
}

export const authedLeftFlyoutAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [HelpAppRoute, SearchAppRoute, CspUserDetailAppRoute],
}

export const authedRightFlyoutAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    CreateVirtualCardAppRoute,
    RequestVirtualCardAppRoute,
    UpdateVirtualCardAppRoute,
    CreateBudgetAppRoute,
    RequestBudgetAppRoute,
    UpdateBudgetAppRoute,
    UpdateBudgetRequestAppRoute,
    TransactionDetailAppRoute,
    PeopleMembersDetailAppRoute,
    PeopleInvitedToOrgDetailAppRoute,
    InvitePeopleAppRoute,
    AddExpenseAppRoute,
    UpdateExpenseAppRoute,
    UpdateBulkTransactionsAppRoute,
    CreateBillPayAppRoute,
    UpdateBillPayVirtualCardAppRoute,
    CreateAutomationRuleAppRoute,
    UpdateAutomationRuleAppRoute,
    BulkUploadExpenseLabelsAppRoute,
  ],
}

export const unauthedAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    SigninAppRoute,
    SignupAppRoute,
    ResetPasswordAppRoute,
    CspSigninAppRoute,
  ],
}

// UNUSED
export const rootAppRoute: AppRoute = {
  routeProps: baseRouteProps,
  subRoutes: [
    authedBackgroundAppRoute,
    authedPopupAppRoute,
    authedLeftFlyoutAppRoute,
    authedRightFlyoutAppRoute,
    unauthedAppRoute,
  ],
}

type FlatAppRoute = {
  path: string
  Component: () => ReactElement
}

export const AuthenticatedFlatArchitectureRoutes: FlatAppRoute[] = [
  {
    path: Routes.PRICING_ROUTE(),
    Component: PricingPage,
  },
  // {
  //   path: Routes.CANCEL_SUBSCRIPTION_ROUTE(),
  //   Component: CancelSubscriptionPage,
  // },
  /* HYGEN-INJECT-ROUTE */
]
